import React from 'react';

// Bandeiras em SVG inline (renderizam em qualquer SO, sem depender de emoji)
const BrFlag = () => (
  <svg viewBox="0 0 28 20" width="24" height="17" aria-hidden="true">
    <rect width="28" height="20" rx="2" fill="#009b3a" />
    <path d="M14 2.5 25 10 14 17.5 3 10z" fill="#fedf00" />
    <circle cx="14" cy="10" r="4" fill="#002776" />
  </svg>
);

const UsFlag = () => {
  const sh = 20 / 13; // altura de cada listra
  const redStripes = [0, 2, 4, 6, 8, 10, 12];
  const stars = [];
  for (let r = 0; r < 4; r++) {
    for (let c = 0; c < 5; c++) {
      stars.push(
        <circle key={`${r}-${c}`} cx={1.3 + c * 2 + (r % 2)} cy={1.3 + r * 2.5} r="0.5" />
      );
    }
  }
  return (
    <svg viewBox="0 0 28 20" width="24" height="17" aria-hidden="true">
      <clipPath id="lang-us-s"><rect width="28" height="20" rx="2" /></clipPath>
      <g clipPath="url(#lang-us-s)">
        <rect width="28" height="20" fill="#fff" />
        {redStripes.map((i) => (
          <rect key={i} y={i * sh} width="28" height={sh} fill="#B22234" />
        ))}
        <rect width="11.5" height={7 * sh} fill="#3C3B6E" />
        <g fill="#fff">{stars}</g>
      </g>
    </svg>
  );
};

/**
 * Seletor de idioma com bandeiras lado a lado (PT / EN).
 * Props: language ('pt' | 'en'), onSelect(lang)
 */
export default function LangSwitch({ language, onSelect }) {
  return (
    <div className="lang-switch" role="group" aria-label="Idioma">
      <button
        type="button"
        className={`lang-flag${language === 'pt' ? ' active' : ''}`}
        onClick={() => onSelect('pt')}
        title="Português"
        aria-label="Português"
        aria-pressed={language === 'pt'}
      >
        <BrFlag />
      </button>
      <button
        type="button"
        className={`lang-flag${language === 'en' ? ' active' : ''}`}
        onClick={() => onSelect('en')}
        title="English"
        aria-label="English"
        aria-pressed={language === 'en'}
      >
        <UsFlag />
      </button>
    </div>
  );
}
